"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreFunctionalCarousel = _interopRequireDefault(require("@legacy-vfuk/core-functional-carousel"));

var _coreBaseProps = require("@legacy-vfuk/core-base-props");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BannerCarousel = function BannerCarousel(_ref) {
  var id = _ref.id,
      srName = _ref.srName,
      waitTime = _ref.waitTime,
      showNavigation = _ref.showNavigation,
      banners = _ref.banners,
      dataSelectorPrefix = _ref.dataSelectorPrefix,
      dataAttributes = _ref.dataAttributes;
  var componentName = 'BannerCarousel';
  return /*#__PURE__*/_react["default"].createElement(_coreFunctionalCarousel["default"], {
    id: id,
    srName: srName,
    slidesToShow: {
      sm: 1,
      md: 1,
      lg: 1,
      xl: 1
    },
    transitionSpeed: 500,
    pager: {
      type: 'loader',
      titles: banners.map(function (_ref2) {
        var title = _ref2.title;
        return title;
      }),
      timeout: waitTime,
      showNavigation: showNavigation
    },
    dataSelectorPrefix: (0, _coreBaseProps.getDataSelector)(dataSelectorPrefix),
    dataAttributes: _objectSpread({
      'data-component-name': componentName
    }, dataAttributes)
  }, banners.map(function (_ref3, index) {
    var child = _ref3.child;
    return /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: index
    }, child);
  }));
};

BannerCarousel.displayName = "BannerCarousel";
var _default = BannerCarousel;
exports["default"] = _default;
//# sourceMappingURL=BannerCarousel.js.map